export const CLASSIFICATION_OPTIONS = [
  { value: 'confirmed', label: 'Подтверждённый простой', shortLabel: 'Прост.', color: '#b42318', background: '#fee4e2' },
  { value: 'late', label: 'Опоздание', shortLabel: 'Опозд.', color: '#b54708', background: '#ffead5' },
  { value: 'potential', label: 'Потенциальный простой', shortLabel: 'Потен.', color: '#7a5d00', background: '#fef0c7' },
  { value: 'upcoming', label: 'Предстоящие ФД', shortLabel: 'Предстоит', color: '#0e9388', background: '#f0fdfa' },
  { value: 'incomplete', label: 'Нет фактических данных', shortLabel: 'Нет ФД', color: '#175cd3', background: '#eff8ff' },
  { value: 'none', label: 'Без классификации', shortLabel: '—', color: '#667085', background: '#ffffff' },
]

const UNKNOWN_CLASSIFICATION = { value: 'none', label: 'Без классификации', shortLabel: '—', color: '#667085', background: '#ffffff' }

const WORK_STATUS_SHORT_LABELS = {
  1: 'Новый',
  2: 'В работе',
  3: 'Назначен',
  9: 'Открыт повторно',
  10: 'В пути',
  13: 'Случайный',
}

export function workStatusShortLabel(item, options) {
  const id = Number(item?.work_status_id)
  if (WORK_STATUS_SHORT_LABELS[id]) return WORK_STATUS_SHORT_LABELS[id]
  const option = (Array.isArray(options) ? options : []).find((value) => value?.value === id)
  const label = option?.label || item?.work_status || ''
  return label.length > 16 ? label.slice(0, 16) : (label || '—')
}

export const REGISTRATION_OPTIONS = [
  { value: 'all', label: 'Все' },
  { value: 'unregistered', label: 'Незарегистрированные' },
  { value: 'registered', label: 'Зарегистрированные' },
]

export const OPERATION_OPTIONS = [
  { value: '', label: 'Все операции' },
  { value: 'loading', label: 'Погрузка' },
  { value: 'unloading', label: 'Выгрузка' },
]

const WORK_STATUS_COLORS = [
  { color: '#175cd3', background: '#eff8ff' },
  { color: '#027a48', background: '#ecfdf3' },
  { color: '#b54708', background: '#fffaeb' },
  { color: '#6941c6', background: '#f4f3ff' },
  { color: '#c01048', background: '#fff1f3' },
  { color: '#344054', background: '#f2f4f7' },
]

export function classificationMeta(value) {
  return CLASSIFICATION_OPTIONS.find((item) => item.value === value)
    || UNKNOWN_CLASSIFICATION
}

export function downtimeStatusMeta(item) {
  if (item?.downtime_lifecycle === 'resolved') {
    return { label: 'Закрыт', color: '#027a48', background: '#ecfdf3' }
  }
  if (item?.downtime_lifecycle === 'registered') {
    return { label: 'Зарегистрирован', color: '#175cd3', background: '#eff8ff' }
  }
  const meta = classificationMeta(item?.downtime_classification)
  return { label: meta.label, color: meta.color, background: meta.background }
}

export function normalizeWorkStatusOptions(payload) {
  const items = Array.isArray(payload)
    ? payload
    : payload?.active_work_statuses || payload?.work_statuses || payload?.items || []
  const seen = new Set()
  return items.map((source, index) => {
    const item = source && typeof source === 'object' ? source : {}
    const fallback = WORK_STATUS_COLORS[index % WORK_STATUS_COLORS.length]
    const value = Number(item.id ?? item.value ?? item.work_status_id)
    const label = String(item.name ?? item.label ?? item.work_status ?? item.id ?? '').trim()
    return {
      value,
      label,
      color: typeof (item.color || item.text_color) === 'string' ? item.color || item.text_color : fallback.color,
      background: typeof (item.background || item.background_color) === 'string' ? item.background || item.background_color : fallback.background,
    }
  }).filter((item) => {
    if (!Number.isInteger(item.value) || item.value <= 0 || !item.label || seen.has(item.value)) return false
    seen.add(item.value)
    return true
  })
}

export function filterSelectedWorkStatusIds(selected, options) {
  const allowed = new Set((Array.isArray(options) ? options : []).map((item) => item?.value))
  return [...new Set((Array.isArray(selected) ? selected : [])
    .map(Number)
    .filter((item) => Number.isInteger(item) && allowed.has(item)))]
}

export function filterSelectedResponsibleIds(selected, options) {
  const allowed = new Set((Array.isArray(options) ? options : []).map((item) => item?.value))
  return [...new Set((Array.isArray(selected) ? selected : [])
    .filter((item) => item === 'none' || allowed.has(item)))]
}

export function normalizeManagerOptions(payload) {
  const items = Array.isArray(payload)
    ? payload
    : payload?.managers || payload?.items || []
  const seen = new Set()
  return items.map((source) => {
    const item = source && typeof source === 'object' ? source : {}
    const value = String(item.id ?? item.value ?? '').trim()
    const label = String(item.name ?? item.label ?? '').trim()
    return { value, label }
  }).filter((item) => {
    if (!item.value || !item.label || seen.has(item.value)) return false
    seen.add(item.value)
    return true
  })
}

export function parseNaiveDateParts(value) {
  if (!value) return null
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/)
  if (!match) return null
  const [, year, month, day, hour, minute] = match
  return { year, month, day, hour, minute }
}

export function formatNaiveDate(value) {
  if (!value) return '—'
  const parts = parseNaiveDateParts(value)
  if (parts) return `${parts.day}.${parts.month}.${parts.year} ${parts.hour}:${parts.minute}`
  return String(value)
}

export function formatNaiveTime(value) {
  if (!value) return '—'
  const parts = parseNaiveDateParts(value)
  if (parts) return `${parts.hour}:${parts.minute}`
  return String(value)
}

export function formatOperation(item) {
  if (item?.operation_type === 'loading') return 'Погрузка'
  if (item?.operation_type === 'unloading') return 'Выгрузка'
  if (item?.operation_type) return item.operation_type
  if (item?.is_loading === true) return 'Погрузка'
  if (item?.is_loading === false) return 'Выгрузка'
  return '—'
}

export function formatRegistrationSource(value) {
  if (value === 'auto') return 'Авто'
  if (value === 'manual') return 'Вручную'
  return '—'
}

export function emailDeliveryMeta(item) {
  const status = item?.email_delivery_status
  if (status === 'accepted') {
    const acceptedAt = formatNaiveDate(item.email_smtp_accepted_at)
    return {
      label: 'Отправлено',
      detail: acceptedAt === '—' ? '' : acceptedAt,
      title: acceptedAt === '—' ? 'SMTP принял письмо' : `SMTP принял письмо: ${acceptedAt}`,
      color: '#027a48',
      background: '#ecfdf3',
    }
  }
  if (status === 'failed') {
    const error = item?.email_smtp_last_error || 'SMTP не принял письмо'
    return { label: 'Ошибка', detail: '', title: error, color: '#b42318', background: '#fee4e2' }
  }
  if (status === 'prepared' || status === 'submitting') {
    return { label: 'Проверяется', detail: '', title: 'Письмо готовится к отправке', color: '#b54708', background: '#fffaeb' }
  }
  if (status === 'ambiguous') {
    return { label: 'Неизвестно', detail: '', title: 'Результат SMTP-отправки не определён', color: '#6941c6', background: '#f4f3ff' }
  }
  return { label: '—', detail: '', title: 'Письмо не отправлялось', color: '#667085', background: '#f2f4f7' }
}

export function formatHours(value) {
  const number = Number(value)
  if (value === null || value === undefined || !Number.isFinite(number)) return '—'
  return number >= 24 ? `${(number / 24).toFixed(1)} д` : `${number.toFixed(1)} ч`
}

export function formatMinutes(value) {
  const number = Number(value)
  if (value === null || value === undefined || !Number.isFinite(number) || number === 0) return '—'
  return number >= 60 ? `${(number / 60).toFixed(1)} ч` : `${Math.round(number)} мин`
}

export const DOWNTIME_HIGHLIGHT_MODES = [
  { value: 'none', label: 'Без подсветки' },
  { value: 'classification', label: 'Класс события' },
  { value: 'work_status', label: 'Статус рейса' },
  { value: 'trip', label: 'Рейс' },
  { value: 'warehouse', label: 'Склад' },
  { value: 'operation', label: 'Операция' },
]

export const HIGHLIGHT_PALETTES = [
  { value: 'colorful', label: 'Цветная' },
  { value: 'zebra', label: 'Зебра' },
  { value: 'bee', label: 'Пчела' },
]

const CLASSIFICATION_HL_COLORS = {
  confirmed: '#fee4e2',
  late: '#ffead5',
  potential: '#fef0c7',
  incomplete: '#eff8ff',
  upcoming: '#f0fdfa',
  resolved: '#ecfdf3',
  none: '#ffffff',
}

export function getDowntimeRowHighlightClass(item, mode, palette, highlightIndex) {
  if (mode === 'classification') {
    const key = item?.downtime_classification || 'none'
    return `hl-cls-${CLASSIFICATION_HL_COLORS[key] ? key : 'none'}`
  }
  if (mode === 'work_status') return `hl-ws-${Number(item?.work_status_id) || 0}`
  if (highlightIndex === null || highlightIndex === undefined) return ''
  return palette === 'zebra' ? `hl-zebra-${highlightIndex % 2}` : palette === 'bee' ? `hl-bee-${highlightIndex % 2}` : `hl-${highlightIndex % 12}`
}

export function getDowntimeHighlightIndexes(items, mode) {
  if (mode === 'none' || mode === 'classification' || mode === 'work_status') return items.map(() => null)
  let prevKey = null
  let idx = -1
  return items.map((item) => {
    let key
    if (mode === 'trip') key = item?.trip_id || item?.cargo_trip_id || null
    else if (mode === 'warehouse') key = item?.warehouse_name || null
    else if (mode === 'operation') key = formatOperation(item)
    else return null
    if (!key) { prevKey = null; return null }
    if (key !== prevKey) { idx = (idx + 1) % 12; prevKey = key }
    return idx
  })
}
